"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const eventConstants_1 = require("../../constants/eventConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const usePrevious_1 = __importDefault(require("../../hooks/usePrevious"));
const button_1 = __importDefault(require("../button/button"));
const messageModal_1 = __importDefault(require("../messageModal/messageModal"));
const messageModalConstant_1 = require("../messageModal/messageModalConstant");
const browserNotificationUtils_1 = require("./browserNotificationUtils");
const BrowserNotification = ({ message }) => {
    // Ensure browser supports notification
    if (!browserNotificationUtils_1.notificationIsSupported) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const [errorMessage, setErrorMessage] = react_1.useState('');
    const [notificationInState, setNotificationInState] = react_1.useState(null);
    const [pageIsHidden, setPageIsHidden] = react_1.useState(document.visibilityState === 'hidden');
    const [WindowOnFocus, setWidowOnFocus] = react_1.useState(true);
    const [requestPermission, setRequestPermission] = react_1.useState(browserNotificationUtils_1.notificationPermissionNotGranted);
    const previousMessage = usePrevious_1.default(message);
    // Note: While onblur and onfocus will tell you if the user switches windows, it doesn't necessarily mean it's hidden.
    // Pages only become hidden when the user switches tabs or minimizes the browser window containing the tab.
    const handleVisibilityChange = () => {
        setPageIsHidden(document.visibilityState === 'hidden');
    };
    const handleBlur = () => {
        setWidowOnFocus(false);
    };
    const handleFocus = () => {
        setWidowOnFocus(true);
    };
    react_1.useEffect(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('blur', handleBlur);
        window.addEventListener('focus', handleFocus);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('blur', handleBlur);
            window.removeEventListener('focus', handleFocus);
        };
    }, []);
    const closeNotification = (tag) => {
        if (browserNotificationUtils_1.serviceWorkerIsSupported) {
            navigator.serviceWorker.ready.then((registration) => {
                registration.getNotifications({ tag }).then((notifications) => {
                    // do something with your notifications
                    notifications.map((notification) => notification.close());
                });
            });
        }
        else if (notificationInState) {
            notificationInState.close();
        }
    };
    react_1.useEffect(() => {
        // Don't do anything if permission isn't granted.
        if (Notification.permission !== typesConstants_1.BROWSER_NOTIFICATION_GRANTED || errorMessage)
            return;
        if (!message && !previousMessage)
            return;
        if (!message && previousMessage) {
            closeNotification(previousMessage.tag);
        }
        else if (message && WindowOnFocus && !pageIsHidden) {
            closeNotification(message.tag);
        }
        else if (message) {
            // Create a new notification when message changes.
            browserNotificationUtils_1.showBrowserNotification(message, setErrorMessage, setNotificationInState);
        }
    }, [message, WindowOnFocus, pageIsHidden]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        requestPermission && !errorMessage && (react_1.default.createElement(button_1.default, { text: "Activate Notification", onPress: () => browserNotificationUtils_1.requestPermissionHandler(setErrorMessage, setRequestPermission), eventName: eventConstants_1.REQUEST_BROWSWER_NOTIFICATION })),
        errorMessage && react_1.default.createElement(messageModal_1.default, { message: errorMessage, type: messageModalConstant_1.WARNING_MESSAGE })));
};
exports.default = BrowserNotification;
